<i18n>
{
  "en": {
    "exchange": "{0} Exchange",
    "fee": "Zero fee",
    "guaranteed": "Guaranteed price",
    "simple": "Simple to use",
    "from": "From",
    "to": "To",
    "enterAmount": "Please enter amount of {0}",
    "orders": "Orders",
    "spotWallet": "Spot wallet available",
    "available": "Available",
    "preview": "Preview Conversion",
    "max": "MAX",
    "price": "Price",
    "inverse": "Inverse price",
    "receive": "You will receive",
    "spend": "You will spend",
    "quoteExpired": "Quote expired. Please request a new quote.",
    "noBalance": "Your account has insufficient balance. Please fund your account.",
    "back": "Back",
    "refresh": "Refresh",
    "confirm": "Confirm",
    "successful": "Successful",
    "converted": "Converted",
    "status": "View Status",
    "search": "Search"
  },
  "zh": {
    "exchange": "{0} 闪存交换",
    "fee": "零费率",
    "guaranteed": "保本价格",
    "simple": "使用简单",
    "from": "卖出",
    "to": "买入",
    "enterAmount": "请输入{0}数量",
    "orders": "订单",
    "spotWallet": "现货钱包可用余额",
    "available": "可得到",
    "preview": "预览兑换结果",
    "max": "最大",
    "price": "价格",
    "inverse": "反向价格",
    "receive": "你将得到",
    "spend": "你将花费",
    "quoteExpired": "该报价已过期，请重新获取报价。",
    "noBalance": "余额不足，请充值。",
    "back": "返回",
    "refresh": "重试",
    "confirm": "确认",
    "successful": "成功",
    "converted": "已兑换",
    "status": "查看状态",
    "search": "搜索"
  },
  "kr": {
    "exchange": "{0} 교환",
    "fee": "제로 수수료",
    "guaranteed": "보증된 가격",
    "simple": "간단한 사용",
    "from": "에서",
    "to": "~에",
    "enterAmount": "금액 {0}을(를) 입력하십시오",
    "orders": "주문",
    "spotWallet": "현물 지갑 사용 가능",
    "available": "사용 가능",
    "preview": "미리보기 변환",
    "max": "최대",
    "price": "가격",
    "inverse": "반품 가격",
    "receive": "받을 것이다",
    "spend": "지출할 것입니다",
    "quoteExpired": "견적이 만료되었습니다. 새 견적을 요청하십시오.",
    "noBalance": "계정 잔액이 부족합니다. 계정에 자금을 입금하십시오.",
    "back": "뒤로",
    "refresh": "새로고침",
    "confirm": "확인",
    "successful": "성공",
    "converted": "변환된",
    "status": "상태 보기",
    "search": "검색"
  }
}
</i18n>
<template>
  <Page style="padding: 0 !important;" :no-line="true" :is-page-loaded="dataLoadingStatus">

    <div style="height: 205px; display: flex; align-items: center; justify-content: center; text-align: center; width: 100%; background: url('/table-bg.png'); padding-bottom: 39px; background-size: cover; background-position: center center;">
      <div>
        <h1 style="margin-bottom: 25px;">{{ $t('exchange', [$store.state.Index.websiteName.short])}}</h1>
        <div>
        <span style="margin-right: 20px;">
          <font-awesome-icon
              :icon="['fal', 'badge-percent']"
              style="margin-right: 5px; color: rgb(50, 217, 147);"
          />
          {{ $t('fee') }}
        </span>
          <span style="margin-right: 20px;">
          <font-awesome-icon
              :icon="['fal', 'badge-check']"
              style="margin-right: 5px; color: rgb(50, 217, 147);"
              class="icon"
          />
          {{ $t('guaranteed') }}
        </span>
          <span>
          <font-awesome-icon
              :icon="['fal', 'badge-dollar']"
              style="margin-right: 5px; color: rgb(50, 217, 147);"
              class="icon"
          />
          {{ $t('simple') }}
        </span>
        </div>
      </div>
    </div>

    <div class="css-header">

      <div class="trade-complete" v-if="completedTrade.isDone">
        <div class="css-81xrsn">
          <svg style="box-sizing: border-box; margin: 0px; min-width: 0px; color: currentcolor; font-size: 90px; fill: currentcolor; width: 1em;height: 1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" fill="none" class="css-ade6fb"><g clip-path="url(#success-b96_svg__clip0)" fill="#00C087"><path d="M71 25a32.523 32.523 0 00-22.96-9.52c-17.95-.01-32.51 14.53-32.52 32.48C15.51 65.91 30.05 80.47 48 80.48c17.95.01 32.51-14.53 32.52-32.48 0-8.63-3.42-16.9-9.52-23zM42.04 60.5L30.97 49.43l2.12-2.12 8.95 8.95 20.91-20.91 2.13 2.13L42.04 60.5zM46.48 2.51L46.56 5H49l.03-2.49h-2.55zm5.65.16l-.22 2.49c.79.07 1.6.17 2.39.28l.36-2.47c-.84-.12-1.69-.22-2.53-.3zm-8.7 0c-.84.08-1.69.19-2.52.33l.39 2.51c.78-.13 1.59-.23 2.38-.35l-.25-2.49zm14.19.83l-.53 2.44c.78.17 1.57.37 2.34.58l.66-2.41c-.81-.23-1.64-.43-2.47-.61zm-19.71.11c-.83.19-1.66.4-2.47.64l.69 2.4c.77-.22 1.56-.42 2.33-.6l-.55-2.44zM63 5l-.79 2.38c.75.26 1.51.55 2.25.86l.92-2.33C64.6 5.58 63.8 5.28 63 5zm-30.46.19c-.79.29-1.59.61-2.37.94l1 2.29c.73-.32 1.48-.61 2.22-.88l-.85-2.35zm-1.37 3.24v-.01c-.01 0-.01.01-.02.01h.02zm36.99-1.24l-1.11 2.24c.71.36 1.43.74 2.12 1.13l1.24-2.17c-.74-.42-1.5-.82-2.25-1.2zm-40.78.24c-.75.38-1.5.79-2.23 1.22l1.26 2.16h.02c.69-.41 1.4-.81 2.09-1.16l-1.14-2.22zM73 10l-1.39 2.07c.69.44 1.36.9 2 1.38l1.48-1.99C74.41 11 73.71 10.47 73 10zm-50.44.26c-.7.49-1.39.97-2.07 1.49l1.51 2c.66-.49 1.32-.96 2-1.41l-1.44-2.08zm54.94 3.08l-1.62 1.91c.61.52 1.21 1.06 1.79 1.61l1.72-1.81c-.59-.59-1.22-1.16-1.89-1.71zm-59.37.34c-.63.56-1.26 1.14-1.87 1.73L18 17.2c.58-.56 1.18-1.11 1.77-1.63l-1.64-1.89zm63.42 3.55l-1.85 1.69c.58.59 1.07 1.2 1.58 1.82l1.93-1.58c-.53-.65-1.09-1.3-1.66-1.93zm-67.4.38c-.56.63-1.12 1.28-1.65 1.94l1.95 1.57c.55-.63 1.03-1.24 1.55-1.84l-1.85-1.67zm70.92 3.97l-2 1.45c.46.65.92 1.33 1.34 2l2.08-1.33c-.42-.72-.93-1.43-1.42-2.12zm-74.4.42c-.48.7-.95 1.41-1.39 2.13l2.13 1.31c.41-.68.86-1.35 1.32-2.01L10.67 22zM88 26.33l-2.22 1.19c.38.7.75 1.43 1.09 2.15l2.28-1.07c-.36-.76-.75-1.53-1.15-2.27zm-80.28.5c-.39.74-.77 1.51-1.12 2.28l2.27 1h.04c.33-.73.69-1.45 1.09-2.11l-2.28-1.17zm82.66 4.58l-2.33.91c.29.74.57 1.51.82 2.27l2.37-.79c-.26-.8-.55-1.61-.86-2.39zm-84.92.48c-.3.8-.58 1.61-.83 2.41l2.37.75c.25-.76.51-1.52.8-2.27l-2.34-.89zm86.65 4.85l-2.42.62c.19.77.37 1.56.53 2.34l2.45-.48c-.16-.83-.35-1.66-.56-2.48zm-88.3.51c-.2.82-.38 1.66-.53 2.49l2.46.45c.14-.78.31-1.58.5-2.35l-2.43-.59zm89.34 4.99l-2.48.31c.1.79.18 1.6.24 2.4l2.49-.18c-.06-.84-.14-1.69-.25-2.53zm-90.32.52c-.1.84-.22 1.7-.22 2.54l2.5.15c.04-.8.11-1.61.2-2.4l-2.48-.29zm88.23 5.07v.14c0 .8-.06 1.61-.06 2.41l2.44.14c.05-.84.07-1.7.12-2.52v-.17h-2.5zm-86.03.53h-2.5c.01.84.04 1.7.1 2.54l2.49-.14c-.09-.79-.09-1.6-.09-2.4zm85.66 4.9c-.1.8-.22 1.6-.36 2.38l2.46.44c.15-.83.28-1.67.38-2.52l-2.48-.3zm-85.29.36l-2.48.32c.11.84.25 1.69.4 2.52l2.46-.47a37.7 37.7 0 01-.38-2.37zm84.32 4.84c-.19.78-.41 1.56-.65 2.32l2.39.74c.25-.8.48-1.63.69-2.45l-2.43-.61zm-83.31.35l-2.42.63c.21.82.45 1.64.71 2.44l2.38-.76c-.24-.76-.47-1.54-.67-2.31zm81.71 4.73c-.28.74-.6 1.49-.93 2.22l2.28 1c.35-.76.68-1.56.98-2.32l-2.33-.9zm-80.07.3l-2.32.92c.31.78.65 1.57 1 2.34L9 66.04c-.33-.72-.65-1.46-.95-2.2zm80.07 5.64l-2.21-1.18c-.37.7-.78 1.41-1.19 2.09l2.13 1.3v.02c.44-.71.87-1.47 1.27-2.23zM10.3 68.6l-2.19 1.2c.4.74.84 1.48 1.28 2.2l2.13-1.32c-.43-.68-.84-1.38-1.22-2.08zm72.78 4.22c-.44.65-.95 1.3-1.44 1.93l2 1.55h.01c.52-.66 1.04-1.3 1.43-2.04l-2-1.44zm-69.99.3l-2 1.46c.5.66 1.01 1.34 1.55 2l1.91-1.54c-.46-.62-.99-1.27-1.46-1.92zm66.73 3.83c-.46.47-.92 1-1.4 1.47l-.27.27 1.76 1.78.28-.28c.48-.51 1-1.02 1.48-1.56l-1.85-1.68zm-63.35.24l-1.84 1.7c.57.62 1.17 1.23 1.78 1.82l1.74-1.8c-.58-.55-1.14-1.13-1.68-1.72zm59.54 3.43c-.6.52-1.23 1.03-1.87 1.52l1.52 2h.01c.67-.51 1.33-1.05 1.97-1.62l-1.63-1.9zm-55.74.23l-1.61 1.91c.66.59 1.33 1.08 2 1.59l1.49-1.99c-.64-.51-1.27-.99-1.88-1.51zm51.46 2.98c-.62.45-1.31.88-2 1.28L71 87.27c.76-.43 1.48-.89 2.12-1.36l-1.39-2.08zm-47.2.17l-1.4 2.11c.71.47 1.44.92 2.17 1.34l1.23-2.19c-.64-.4-1.33-.82-2-1.26zm42.65 2.51c-.71.34-1.45.68-2.18 1l1 2.29c.81-.34 1.59-.7 2.3-1.06l-1.12-2.23zm-38.05.18l-1.1 2.25c.76.37 1.54.73 2.32 1.06l.97-2.31c-.73-.3-1.47-.64-2.19-1zm33.23 1.87c-.76.27-1.53.52-2.29.74l.7 2.4c.81-.24 1.62-.5 2.42-.78l-.83-2.36zM34 88.68l-.79 2.36c.8.28 1.62.54 2.43.77l.66-2.41c-.77-.22-1.54-.46-2.3-.72zm23.27 1.34c-.78.17-1.57.32-2.36.45l.4 2.47c.83-.14 1.69-.3 2.5-.48l-.54-2.44zm-18.15.07l-.52 2.45c.83.17 1.68.33 2.51.46l.38-2.48c-.79-.12-1.59-.26-2.37-.43zm12.93.75c-.8.08-1.6.16-2.4.16l.09 2.49c.84-.03 1.7-.09 2.54-.16l-.23-2.49zm-7.7.02l-.21 2.5c.85.07 1.7.14 2.54.14l.08-2.5c-.8-.02-1.61-.07-2.41-.14z"></path></g><defs><clipPath id="success-b96_svg__clip0"><path fill="#fff" d="M0 0h96v96H0z"></path></clipPath></defs></svg></div>
        <div style="margin-top: 18px; font-weight: 500; color: rgb(30, 35, 41); font-size: 20px; line-height: 24px;">
          {{ $t('successful') }}</div>
        <div style="margin-top: 32px; color: rgb(72, 81, 93); font-size: 14px; line-height: 18px;">{{ $t('spend') }}</div>
        <div style="line-height: 34px; font-size: 24px; color: rgb(30, 35, 41); margin-top: 6px; margin-bottom: 30px;">{{ completedTrade.info.isBuyerMaker ? (completedTrade.info.amount * completedTrade.info.price).toFixed(6) : completedTrade.info.amount.toFixed(6) }} {{ completedTrade.info.isBuyerMaker ? completedTrade.info.market : completedTrade.info.coin }}</div>
        <div class="quote-infos">
          <div>{{ $t('converted') }}</div>
          <div class="value">{{ completedTrade.info.isBuyerMaker ? completedTrade.info.amount.toFixed(6) : (completedTrade.info.price * completedTrade.info.amount).toFixed(6) }} {{ completedTrade.info.isBuyerMaker ? completedTrade.info.coin : completedTrade.info.market }}</div>
        </div>
        <div class="quote-infos">
          <div>{{ $t('price') }}</div>
          <div class="value">1 {{ completedTrade.info.coin }} = {{ completedTrade.info.price.toFixed(6) }} {{ completedTrade.info.market }}</div>
        </div>
        <div class="quote-infos">
          <div>{{ $t('inverse') }}</div>
          <div class="value">1 {{ completedTrade.info.market }} = {{ (1 / completedTrade.info.price).toFixed(6) }} {{ completedTrade.info.coin }}</div>
        </div>

        <div style="display: flex; justify-content: space-between; margin-top: 20px;">
          <Button
              custom-width="50%"
              style="background: rgb(234, 236, 239); color: rgb(30, 35, 41);"
              :is-async="false"
              :callback="() => reverseInputs(false)"
          >
            {{ $t('back') }}
          </Button>
          <Button
              custom-width="50%"
              style="margin-left: 20px;"
              :is-async="false"
              :callback="() => $router.push($linkCreator($i18n.locale, 'dashboard/orders'))"
          >
            {{ $t('status') }}
          </Button>
        </div>
      </div>

      <div class="terminal col-lg-5 col-md-6 col-xs-12" v-if="dataLoadingStatus.isDone && !completedTrade.isDone">
        <div style="width: 100%; display: flex; justify-content: end; margin-bottom: 50px;">
          <div @click="$router.push($linkCreator($i18n.locale, 'dashboard/orders'))" style="padding: 10px 16px; line-height: 20px; font-size: 14px; cursor: pointer; border-radius: 4px; background-color: rgb(234, 236, 239); display: flex;">
            <svg style="width: 20px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="css-ifou49">
              <path d="M8 15h8v2H8v-2z" fill="currentColor"></path>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4 2h9.414L20 8.586V22H4V2zm2 2v16h12v-9h-7V4H6zm7 .414V9h4.586L13 4.414z"
                    fill="currentColor"></path>
            </svg>
            <div style="margin: 0px 0px 0px 8px;" data-bn-type="text" class="t css-lzd0h4">{{ $t('orders') }}</div>
          </div>
        </div>

        <div style="margin-bottom: 30px; position: relative;">
          <div style="margin-bottom: 10px; display: flex; justify-content: space-between;">
            <span>{{ $t('from') }}</span>
            <span>{{ Object.keys(balance).length > 0 ? $t('spotWallet') : $t('available') }}: {{ Object.keys(balance).length > 0 ? balance[currentPair.coin].spotWallet.toFixed(6) : '-' }} {{ currentPair.coin }}</span>
          </div>
          <div class="input-group">
            <input
                class="amount-input"
                :placeholder="receiveAmount !== '' ? '-' : $t('enterAmount', [currentPair.coin])"
                type="number"
                v-model="sendAmount"
                min="0"
            >
            <div @click="$store.state.Index.isAuthed ? sendAmount = +balance[currentPair.coin].spotWallet.toFixed(6) : null" style="box-sizing: border-box; margin: 0px 16px 0px 8px; min-width: 0px; cursor: pointer; color: #2A85FF; font-size: 12px; display: block;">{{ $t('max') }}</div>
            <div class="choose-pair" @click="openCoinsWindow('coins')">
              <div class="slash"></div>
              <img style=" width: 100%; height: 100%; vertical-align: unset; margin-right: 5px;" :src="`/currencies/${currentPair.coin}.png`" alt="">
              <div>{{ currentPair.coin }}</div>
              <font-awesome-icon
                  style="margin-left: 10px; font-size: 12px; transition: 0.3s;"
                  :icon="['fas', isCoinsOpen ? 'chevron-up' : 'chevron-down']"
                  class="icon"
              />
            </div>
          </div>
          <transition name="fade">
            <div class="hidden-body" v-show="isCoinsOpen">
              <div class="search">
                <input v-model="searchCoin" type="text" :placeholder="$t('search')">
                <font-awesome-icon
                    :icon="['fas', 'search']"
                    class="icon"
                />
              </div>
              <div class="pairs">
                <div @click="changeCoin(pair)" class="pair" v-for="pair, index in filteredCoinsPairs" :key="'selling list'+index">
                  <div class="name">
                    <div style="width: 20px; height: 20px; margin-right: 5px;">
                      <img style=" width: 100%; height: 100%; vertical-align: unset;" :src="`/currencies/${pair.code}.png`" alt="">
                    </div>
                    <span>{{ pair.code }}</span>
                  </div>
                  <div v-if="$store.state.Index.isAuthed">
                    <span class="value">{{ balance[pair.code].spotWallet.toFixed(6) }}</span>
                    <span class="description">≈ ${{ (balance[pair.code].spotWallet * coinList.find(x => x.code === pair.code).usdPrice).toFixed(2) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div style="display:flex;">
          <div class="reverse-btn" @click="reverseInputs">
            <font-awesome-icon
                :icon="['fal', 'long-arrow-up']"
                class="icon"
            />
            <font-awesome-icon
                :icon="['fal', 'long-arrow-down']"
                class="icon"
            />
          </div>
        </div>

        <div style="margin-bottom: 20px; position: relative;">
          <div style="margin-bottom: 10px; display: flex; justify-content: space-between;">
            <span>To</span>
          </div>
          <div class="input-group">
            <input
                class="amount-input"
                :placeholder="sendAmount !== '' ? '-' : $t('enterAmount', [currentPair.market])"
                type="number"
                v-model="receiveAmount"
                min="0"
            >
            <div class="choose-pair" @click="openCoinsWindow('markets')">
              <div class="slash"></div>
              <img style=" width: 100%; height: 100%; vertical-align: unset; margin-right: 5px;" :src="`/currencies/${currentPair.market}.png`" alt="">
              <div>{{ currentPair.market }}</div>
              <font-awesome-icon
                  style="margin-left: 10px; font-size: 12px; transition: 0.3s;"
                  :icon="['fas', isMarketsOpen ? 'chevron-up' : 'chevron-down']"
                  class="icon"
              />
            </div>
          </div>
          <transition name="fade">
            <div class="hidden-body" v-show="isMarketsOpen">
              <div class="search">
                <input v-model="searchMarket" type="text" :placeholder="$t('search')">
                <font-awesome-icon
                    :icon="['fas', 'search']"
                    class="icon"
                />
              </div>
              <div class="pairs">
                <div @click="changeMarket(pair)" class="pair" v-for="pair, index in filteredMarketPairs" :key="'buying list'+index">
                  <div class="name">
                    <div style="width: 20px; height: 20px; margin-right: 5px;">
                      <img style=" width: 100%; height: 100%; vertical-align: unset;" :src="`/currencies/${pair.code}.png`" alt="">
                    </div>
                    <span>{{ pair.code }}</span>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div :style="isQuoteExpired ? 'color: rgb(183, 189, 198)' : null" v-show="conversionInfo.price !== 0">
          <div class="quote-infos">
            <div>{{ $t('price') }}</div>
            <div class="value">1 {{ currentPair.coin }} = {{ conversionInfo.price.toFixed(6) }} {{ currentPair.market }}</div>
          </div>
          <div class="quote-infos">
            <div>{{ $t('inverse') }}</div>
            <div class="value">1 {{ currentPair.market }} = {{ conversionInfo.priceInverse.toFixed(6) }} {{ currentPair.coin }}</div>
          </div>
          <div class="quote-infos" style="border-bottom: 1px solid rgb(230, 232, 234);">
            <div>{{ conversionInfo.isSpending ? $t('receive') : $t('spend') }}</div>
            <div class="value" :style="{ color: isQuoteExpired ? 'rgb(183, 189, 198)' : '#2A85FF' }" style="font-size: 24px;">{{ conversionInfo.amount.toFixed(6) }} {{ conversionInfo.isSpending ? isSell ? currentPair.market : currentPair.coin : isSell ? currentPair.coin : currentPair.market }}</div>
          </div>
        </div>

        <div style="color: rgb(207, 48, 74); font-size: 12px; margin-top: 5px;" v-show="isQuoteExpired || !isBalanceEnough">
          {{ isQuoteExpired ? $t('quoteExpired') : !isBalanceEnough ? $t('noBalance') : '' }}
        </div>

        <div style="margin-top: 20px;">
          <div style="display: flex; justify-content: space-between;" v-if="conversionInfo.price !== 0">
            <Button
                custom-width="50%"
                style="background: rgb(234, 236, 239); color: rgb(30, 35, 41);"
                :is-async="false"
                :callback="() => reverseInputs(false)"
            >
              {{ $t('back') }}
            </Button>
            <Button
                custom-width="50%"
                style="margin-left: 20px;"
                :is-async="true"
                :callback="isQuoteExpired || !isBalanceEnough ? getConversion : confirmExchange"
                :is-disabled="sendAmount === '' && receiveAmount === ''"
                :answerDelay="1000"
            >
              {{ isQuoteExpired || !isBalanceEnough ? $t('refresh') : `${$t('confirm')} (${expireTimerNumber}s)` }}
            </Button>
          </div>
          <div v-else>
            <Button
                custom-width="100%"
                :is-async="true"
                :callback="$store.state.Index.isAuthed ? getConversion : () => $router.push($linkCreator($i18n.locale, 'auth'))"
                :is-disabled="sendAmount === '' && receiveAmount === ''"
                :answerDelay="1000"
            >
              {{ $t('preview') }}
            </Button>
          </div>
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from "@/components/main/UI/Page";
import axios from "@/plugins/axios";
import Button from "@/components/main/UI/Button";
import * as workerTimers from 'worker-timers';
import * as workerInterval from "worker-interval";

export default {
  name: "ExchangeSimple",
  components: {
    Page,
    Button
  },
  data() {
    return {
      completedTrade: {
        isDone: false,
        info: {}
      },
      isSell: true,
      currentPair: {
        priceChange: {
          price: 19110.38,
          volume: 1470.181435490196
        },
        priceLow24h: 18950.01,
        priceHigh24h: 19441.99,
        coin: 'BTC',
        market: 'USDT'
      },
      sendAmount: '',
      receiveAmount: '',
      balance: {},
      conversionInfo: {
        price: 0,
        priceInverse: 0,
        isSpending: false,
        isBuyerMaker: false,
        amount: 0,
        expireTime: 20,
        expireTimestamp: 0,
      },
      expireInterval: null,
      expireTimerNumber: 0,
      isQuoteExpired: false,
      isBalanceEnough: true,
      markets: [],
      pairs: [],
      coinList: [],
      searchCoin: '',
      searchMarket: '',
      isCoinsOpen: false,
      isMarketsOpen: false,
      dataLoadingStatus: {
        isDone: false,
        isError: false
      },
    }
  },
  watch: {
    sendAmount(newValue) {
      if (newValue === '') return;
      if (this.expireInterval || this.conversionInfo.price !== 0) {
        workerInterval.clearInterval(this.expireInterval);
        this.expireInterval = null;
        this.isQuoteExpired = false;
        this.isBalanceEnough = true;
        this.conversionInfo = { price: 0, priceInverse: 0, isSpending: false, amount: 0 };
      }
      this.receiveAmount = '';
      },
    receiveAmount(newValue) {
      if (newValue === '') return;
      if (this.expireInterval || this.conversionInfo.price !== 0) {
        workerInterval.clearInterval(this.expireInterval);
        this.expireInterval = null;
        this.isQuoteExpired = false;
        this.isBalanceEnough = true;
        this.conversionInfo = { price: 0, priceInverse: 0, isSpending: false, amount: 0 };
      }
      this.sendAmount = '';
    }
  },
  methods: {
    async getConversion() {
      try {
        this.isQuoteExpired = false;
        let fetchedData = await axios.post('main/user/order-conversion', {
          isBuyerMaker: !this.isSell,
          currentPair: this.currentPair,
          sendAmount: this.sendAmount,
          receiveAmount: this.receiveAmount
        });
        if (fetchedData.data.error) return this.$callNotification(this.$i18n.locale, fetchedData);

        this.conversionInfo = fetchedData.data.conversionInfo;
        this.balance = fetchedData.data.balance;
        this.isBalanceEnough = fetchedData.data.isBalanceEnough;
        if (this.isBalanceEnough) {
          this.expireInterval = workerInterval.setInterval(() => {
            this.expireTimerNumber = Math.round((this.conversionInfo.expireTimestamp - Date.now()) / 1000)
            if (this.expireTimerNumber <= 0) {
              workerInterval.clearInterval(this.expireInterval);
              return this.isQuoteExpired = true;
            }
          }, 200);
        }
      } catch (e) {
        console.log(e)
      }
    },
    async confirmExchange() {
      try {
        if (!this.conversionInfo._id) return;
        this.isQuoteExpired = false;
        let fetchedData = await axios.post('main/user/simple-order', {
          quoteId: this.conversionInfo._id
        });
        if (fetchedData.data.error) return this.$callNotification(this.$i18n.locale, fetchedData);

        this.completedTrade.info = fetchedData.data.orderInfo;
        this.balance = fetchedData.data.balance;
        this.completedTrade.isDone = true;
      } catch (e) {
        console.log(e)
      }
    },
    reverseInputs(changeWay=true) {
      this.completedTrade.isDone = false;
      if (this.expireInterval) {
        workerInterval.clearInterval(this.expireInterval);
        this.expireInterval = null;
      }
      this.isQuoteExpired = false;
      this.isBalanceEnough = true;
      this.receiveAmount = '';
      this.sendAmount = '';
      if (changeWay) [this.currentPair.coin, this.currentPair.market] = [this.currentPair.market, this.currentPair.coin];
      this.conversionInfo = { price: 0, priceInverse: 0, isSpending: false, amount: 0 };
      this.updatePageTitle(this.isSell ? `${this.currentPair.coin}/${this.currentPair.market}` : `${this.currentPair.market}/${this.currentPair.coin}`);
    },
    openCoinsWindow(windowType) {
      this.searchCoin = '';
      this.searchMarket = '';
      const window = windowType === 'coins' ? 'isCoinsOpen' : 'isMarketsOpen';
      this[window] = !this[window];
      windowType === 'coins' ? this.isMarketsOpen = false : this.isCoinsOpen = false;
    },
    updatePageTitle(pair) {
      document.title = `${pair} | ${this.$store.state.Index.websiteName.short}`;
    },
    async changeCoin(pair) {
      if (pair.code === this.currentPair.coin) return;
      this.currentPair.coin = pair.code;
      this.updatePageTitle(`${this.currentPair.coin}/${this.currentPair.market}`);
      this.reverseInputs(false);
      this.isMarketsOpen = false;
      this.isCoinsOpen = false;
    },
    async changeMarket(market) {
      if (market.code === this.currentPair.market) return;
      this.currentPair.market = market.code;
      this.updatePageTitle(`${this.currentPair.coin}/${this.currentPair.market}`);
      this.reverseInputs(false);
      this.isMarketsOpen = false;
      this.isCoinsOpen = false;
    },
    async getPairsInfo() {
      this.dataLoadingStatus.isDone = false;
      this.dataLoadingStatus.isError = false;
      try {
        if (!this.$route.params.pair) return location.href = this.$linkCreator(this.$i18n.locale, 'exchange/BTC_USDT');
        let fetchedData = await axios.get('main/exchange/terminalSimple');
        if (fetchedData.data.error) {
          this.dataLoadingStatus.isDone = true;
          this.dataLoadingStatus.isError = true;
          return;
        }
        this.pairs = fetchedData.data.pairs;
        this.markets = fetchedData.data.markets;
        this.coinList = fetchedData.data.coinList;
        this.balance = fetchedData.data.balance;
        this.updatePageTitle(`${this.currentPair.coin}/${this.currentPair.market}`);
        const routePair = { coin: this.$route.params.pair.split('_')[0], market: this.$route.params.pair.split('_')[1] };
        const isRoutePairExist = this.pairs.find(x => x.coin === routePair.coin && x.market === routePair.market);
        this.currentPair = isRoutePairExist || this.pairs.find(x => x.market === 'USDT');
        this.dataLoadingStatus.isDone = true;
      } catch (e) {
        if (e.response?.status === 404) return this.$router.push('/');
        console.log(e)
        this.dataLoadingStatus.isDone = true;
        this.dataLoadingStatus.isError = true;
      }
    }
  },
  computed: {
    filteredCoinsPairs() {
      return this.coinList.filter(x => x.code !== this.currentPair.market && x.code.toLowerCase().includes(this.searchCoin.toLowerCase()));
    },
    filteredMarketPairs() {
      return this.coinList.filter(x => x.code !== this.currentPair.coin && x.code.toLowerCase().includes(this.searchMarket.toLowerCase()));
    }
  },
  async mounted() {
    await this.getPairsInfo();
  }
}
</script>

<style lang="scss" scoped>

.quote-infos {
  margin-bottom: 10px;
  align-items: center;
  display: flex;
  justify-content: space-between;

  .value {
    font-size: 12px;
  }
}

.css-header {
  width: 100%;
  background: white;
  color: black;
  padding: 28px 0px 100px;
  border-top-left-radius: 39px;
  border-top-right-radius: 39px;
  height: calc(100vh - 265px);
  display: flex;
}

.trade-complete {
  width: 384px;
  padding: 26px 36px 40px;
  box-sizing: border-box;
  min-width: 0px;
  margin: auto;
  display: flex;
  border-radius: 4px;
  box-shadow: rgba(24, 26, 32, 0.1) 0px 0px 1px, rgba(71, 77, 87, 0.04) 0px 3px 6px, rgba(24, 26, 32, 0.04) 0px 1px 2px;
  background-color: rgb(255, 255, 255);
  text-align: center;
  -webkit-box-align: stretch;
  align-items: stretch;
  flex-direction: column;
}

.terminal {
  margin-left: auto;
  margin-right: auto;
  padding: 15px;

  .reverse-btn {
    margin: auto;
    color: rgb(112, 122, 138);
    border-radius: 100%;
    height: 30px;
    width: 30px;
    background-color: rgb(245, 245, 245);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 15px;

    &:hover {
      color: #cbcaff;
    }
  }

  .input-group {
    padding: 5px 15px;
    position: relative;
    border: 1px solid transparent;
    transition: .3s;
    box-sizing: border-box;
    margin: 0px;
    min-width: 0px;
    display: inline-flex;
    -webkit-box-align: center;
    align-items: center;
    line-height: 1.6;
    background-color: rgb(245, 245, 245);
    border-radius: 4px;
    height: 48px;
    width: 100%;

    &:focus-within {
      border: 1px solid #2A85FF;
      background: white;
    }
    .amount-input {
      width: 100%;
      border: none;
      background: transparent;
      outline: none;
    }
    .choose-pair {
      min-width: 120px;
      justify-content: space-evenly;
      display: flex;
      align-items: center;
      cursor: pointer;

      .slash {
        box-sizing: border-box;
        margin: 0px 16px 0px 0px;
        min-width: 0px;
        width: 1px;
        background-color: rgb(234, 236, 239);
        height: 26px;
      }
      img {
        max-width: 20px;
      }
    }
  }

  .hidden-body {
    position: absolute;
    z-index: 9999;
    top: 100%;
    width: 100%;
    left: 0;
    padding: 16px 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(24, 26, 32, 0.1) 0px 0px 1px, rgba(71, 77, 87, 0.08) 0px 7px 14px, rgba(24, 26, 32, 0.08) 0px 3px 6px;
    border-radius: 4px;
    -webkit-transition: .18s ease-out;
    -o-transition: .18s ease-out;
    transition: .18s ease-out;

    ::-webkit-scrollbar-track {
      background-color: white !important;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #a4a4a4;
    }

    .search {
      position: relative;
      padding: 0 16px;

      .icon {
        position: absolute;
        top: 11px;
        left: 30px;
        color: rgb(183, 189, 198);
      }
      input {
        position: relative;
        width: 100%;
        display: block;
        margin-bottom: 16px;
        padding: 8px 12px 8px 36px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border: none;
        border-radius: 10px;
        background-color: whitesmoke;
        color: black;
        font-weight: 500;
        line-height: 20px;
        outline: 0;
      }
    }

    span.enable-markets {
      margin-right: 16px;
      display: inline-block;
      padding: 0;
      border: none;
      border-radius: 0;
      background-color: transparent;
      color: black;
      font-size: 14px;
      font-weight: 600;
      line-height: 25px;
      text-transform: uppercase;
      outline: 0;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      cursor: pointer;
      -webkit-transition: .1s ease-out;
      -o-transition: .1s ease-out;
      transition: .1s ease-out;
      margin-bottom: 5px;

      &.current {
        color: black;
        border-bottom: 2px solid white;
      }
    }
    .pairs {
      max-height: 240px;
      overflow-y: auto;
      margin-top: 15px;

      .pair {
        display: flex;
        margin-bottom: 10px;
        cursor: pointer;
        transition: .3s;
        padding: 5px 16px;
        justify-content: space-between;

        &:hover { background-color: rgb(245, 245, 245); }

        div.name { font-size: 12px; display: flex; align-items: center; width: 200px; }
        span {
          display: block;
          width: 80px;

          &.value {
            color: black;
            font-size: 12px;
            font-weight: 500;
          }
          &.description {
            color: #697d94;
            font-size: 11px;
            font-weight: 500;
            text-transform: uppercase;
          }
        }
      }
    }
  }
}

</style>